﻿<form @submit.prevent="search" class="vl-form aeg-u-bg-alt aeg-u-box-padding">
    <div class="aeg-u-bg-white aeg-u-box-padding">
        <vl-form-grid mod-stacked>
            <vl-column width="3" width-s="6" width-xs="12" v-for="field in searchFields" :key="field.key">
                <vl-radio :id="uniqueFieldId(field.key)" :value="field.key" v-model="searchField"
                          name="filter">{{ field.label }}</vl-radio>
            </vl-column>
            <vl-column width="12">
                <vl-input-field name="keyword" :placeholder="keywordPlaceHolder" autocomplete="off" v-model="keyword"
                                mod-block />
            </vl-column>
            <vl-column v-vl-visually-hidden>
                <vl-action-group>
                    <vl-button type="submit" v-vl-visually-hidden>Zoeken</vl-button>
                </vl-action-group>
            </vl-column>
        </vl-form-grid>
    </div>
</form>